/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type Http3xxRedirectsRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Http3xxRedirectsTable_project$ref: FragmentReference;
export type Http3xxRedirectsTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +countTypesHttp3xxRedirects: ?$ReadOnlyArray<?{|
          +type: string,
          +severity: number,
          +count: number,
        |}>,
        +countCodesHttp3xxRedirects: ?$ReadOnlyArray<?{|
          +code: number,
          +count: number,
        |}>,
        +http3xxRedirects: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: Http3xxRedirectsRow_issue$ref
            |}
          |}>,
        |},
      |}
    |}>
  |},
  +$refType: Http3xxRedirectsTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v1 = {
  "kind": "Variable",
  "name": "codeFilters",
  "variableName": "codeFilters",
  "type": "[Int]"
},
v2 = {
  "kind": "Variable",
  "name": "redirectUrl",
  "variableName": "redirectUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "typeFilters",
  "variableName": "typeFilters",
  "type": "[String]"
};
return {
  "kind": "Fragment",
  "name": "Http3xxRedirectsTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "codeFilters",
      "type": "[Int]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "typeFilters",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "redirectUrl",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "sourceUrl",
      "type": "TextFilters",
      "defaultValue": v0
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countTypesHttp3xxRedirects",
                  "storageKey": null,
                  "args": [
                    v1,
                    v2,
                    v3
                  ],
                  "concreteType": "CountType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "severity",
                      "args": null,
                      "storageKey": null
                    },
                    v4
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countCodesHttp3xxRedirects",
                  "storageKey": null,
                  "args": [
                    v2,
                    v3,
                    v5
                  ],
                  "concreteType": "CountCode",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "code",
                      "args": null,
                      "storageKey": null
                    },
                    v4
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "http3xxRedirects",
                  "storageKey": null,
                  "args": [
                    v1,
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    v2,
                    v3,
                    v5
                  ],
                  "concreteType": "Http3xxRedirectsConnection",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Http3xxRedirectsEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Http3xxRedirect",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "Http3xxRedirectsRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f8bcd460f28803e06a26cf6c2425598d';
module.exports = node;
